import { object, setLocale, string } from 'yup'

setLocale({
  mixed: {
    default: 'common.required'
  }
})

export default function getValidationSchema(action: string) {
  if (action !== 'approve') {
    return object().shape({
      justification: string().trim().required()
    })
  }
  return object().shape({
    justification: string().trim().notRequired()
  })
}
